import { ROUTER_BASE_URL } from 'constants/app';

if (!window.location.pathname.includes(ROUTER_BASE_URL)) {
  window.history.replaceState('', '', `${ROUTER_BASE_URL}${window.location.pathname}`);
}

if (window.location.pathname === `${ROUTER_BASE_URL}/`) {
  window.history.replaceState('', '', `${ROUTER_BASE_URL}${window.location.search}`);
}
